import React, { useState, useEffect } from 'react';
import { Box, Typography, Divider } from '@mui/material';
import InvoiceForm from './InvoiceForm';
import MainMeterConsumption from './MainMeterConsumption';
import SubMeterInputs from './SubMeterInputs';
import ResultSummary from './ResultSummary';
import RatingService from '../RatingService';

const FreeConsumptionFlow = () => {
  const [invoiceData, setInvoiceData] = useState(null);
  const [mainConsumptions, setMainConsumptions] = useState({});
  const [subMeters, setSubMeters] = useState([]);
  const [ratingResult, setRatingResult] = useState(null);

  useEffect(() => {
    if (invoiceData && Object.keys(mainConsumptions).length > 0) {
      const request = buildRequest();
      RatingService.rating(request).then(res => setRatingResult(res.data));
    }
  }, [invoiceData, mainConsumptions, subMeters]);

  const buildRequest = () => {
    // Ana sayaç + alt sayaç verilerinden backend'e gidecek nesne hazırlanır.
    return {
      startDate: invoiceData.startDate,
      endDate: invoiceData.endDate,
      tariffId: invoiceData.tariffId,
      subsidized: invoiceData.subsidized,
      contractPowerChargeSharing: invoiceData.contractPowerChargeSharing,
      exceededPowerChargeSharing: invoiceData.exceededPowerChargeSharing,
      consumptionListByPriorityDtoos: [] // detay sonra eklenecek
    };
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4">Fatura Hesaplama</Typography>
      <Divider sx={{ my: 2 }} />

      <InvoiceForm onChange={setInvoiceData} />
      {invoiceData && (
        <>
          <MainMeterConsumption
            indexTypes={invoiceData.indexTypes}
            onChange={setMainConsumptions}
          />

          <ResultSummary ratingResult={ratingResult} />

          <Divider sx={{ my: 2 }} />
          <SubMeterInputs
            validIndexTypes={invoiceData.indexTypes.filter(i => i.indexType !== 'P' && i.indexType !== 'D')}
            onChange={setSubMeters}
          />
        </>
      )}
    </Box>
  );
};

export default FreeConsumptionFlow;
